// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionModalStripe_container__AzoEE","subscriptionCard":"SubscriptionModalStripe_subscriptionCard__boll4","iconArea":"SubscriptionModalStripe_iconArea__TlnGP"};